import bannerService from '@/services/banner'

export default {
  getData ({commit}, params = {}) {
    return new Promise((resolve, reject) => {
      bannerService.getData({
        params,
        headers: {
          'Authorization': localStorage.token
        }
      })
        .then(response => {
          const banner = response.data.data
          banner.forEach(item => {
            item.file_url = null
            if(item.file !== null) {
              item.file_url = process.env.VUE_APP_STORAGE + '/' + item.file
            }
						
          })
          commit('SET_DATA', banner)
          resolve(banner)
        })
        .catch(e => reject(e))
    })
  }
}